/**
 * Simple Markdown to HTML renderer for blog text blocks.
 * Handles: headings, bold, italic, links, lists, paragraphs.
 */
export function renderMarkdown(text: string): string {
  // Split into lines
  const lines = text.split("\n");
  let html = "";
  let inList = false;

  for (let i = 0; i < lines.length; i++) {
    let line = lines[i];

    // Headings
    if (line.startsWith("### ")) {
      if (inList) { html += "</ul>"; inList = false; }
      html += `<h3>${inlineFormat(line.slice(4))}</h3>`;
      continue;
    }
    if (line.startsWith("## ")) {
      if (inList) { html += "</ul>"; inList = false; }
      html += `<h2>${inlineFormat(line.slice(3))}</h2>`;
      continue;
    }
    if (line.startsWith("# ")) {
      if (inList) { html += "</ul>"; inList = false; }
      html += `<h1>${inlineFormat(line.slice(2))}</h1>`;
      continue;
    }

    // List items
    if (line.startsWith("- ") || line.startsWith("* ")) {
      if (!inList) { html += "<ul>"; inList = true; }
      html += `<li>${inlineFormat(line.slice(2))}</li>`;
      continue;
    }

    // Close list if not a list item
    if (inList) { html += "</ul>"; inList = false; }

    // Empty line = paragraph break
    if (line.trim() === "") {
      continue;
    }

    // Regular paragraph
    html += `<p>${inlineFormat(line)}</p>`;
  }

  if (inList) html += "</ul>";

  return html;
}

function inlineFormat(text: string): string {
  // Bold
  text = text.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  // Italic
  text = text.replace(/\*(.+?)\*/g, "<em>$1</em>");
  // Links
  text = text.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" class="text-secondary hover:underline">$1</a>');
  return text;
}

export function getBlogImageUrl(path: string | null): string {
  if (!path) return "/placeholder-product.png";
  if (path.startsWith("http")) return path;
  return `/api/blog-images/${path}`;
}

export function formatBlogDate(dateStr: string): string {
  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(dateStr));
}
